import React from 'react';
import ConsentFormsUtil from "./utils/ConsentFormsUtil";
import {TextInput} from "../../components";
import SignatureInput from "../../components/signature-input/SignatureInput";
import FormField from "../../components/form/FormField";
import DateUtil from "../../utils/DateUtil";
import TeleconsultationFormTextEnum from "./teleconsultation/enum/TeleconsultationFormTextEnum";
import SignatureDisplay from '../../components/signature-input/SignatureDisplay';
import {YesNoRadioInput} from "./public/YesNoRadioInput";
import { isMinor } from '../patient/Patient';

const TeleconsultationWizardPage = ({
    patient,
    form,
    readOnly,
    patientName,
    patientDOB,
    mrnNo,
    onSavePatientSignature,
    onSaveWitnessSignature,
    pushFormFieldRef,
    participateInTeleconsultation,
    guardianName,
    guardianRelationship,
    patientSignature,
    patientDate,
    witnessName,
    witnessSignature,
    providerName,
    providerSignature,
    selectedLanguage,
    enumLabel,
    ...commonProps
}) => {
    const { onChange } = commonProps;
    const textEnum = TeleconsultationFormTextEnum;
    const isPatientMinor = isMinor(patientDOB, 'UAE');

    const getLocalizedText = (key) => {
        return textEnum[key] ? textEnum[key][selectedLanguage] : '';
    };

    return (
        <div style={{maxWidth: '950px'}}>
            <div style={{
                marginTop: '15px', marginBottom: '15px', width: '100%', display: 'flex',
                flexFlow: 'row', justifyContent: 'space-between', alignItems: 'center'
            }}>
                <h2>{getLocalizedText('Teleconsultation_Consent_Form_Title')}</h2>
            </div>

            <hr style={{
                borderTop: "2px solid #000000",
                marginTop: "-10px",
                boxShadow: "0px 2px 2px #797979"
            }}/>

            <div style={{border: "1px solid #000000"}}>
                <div style={{margin: "15px 15px"}}>
                    <h5>{getLocalizedText('Patient_Information')}</h5>
                    <div className={"row"} style={{marginTop: "10px", marginLeft: "0px"}}>
                        <div className="col-md-5">
                            <b>{getLocalizedText('Name')}</b> {patientName}
                        </div>
                        <div className="col-md-4">
                            <b>{getLocalizedText('MRN')}</b> {mrnNo}
                        </div>
                        <div className="col-md-3">
                            <b>{getLocalizedText('DOB')}</b> {DateUtil.formatDate(patientDOB)}
                        </div>
                    </div>
                </div>
            </div>

            <div style={{border: "1px solid #000000", margin: "10px 0px"}}>
                <div style={{margin: "15px 15px"}}>
                    {getLocalizedText('Treatment_Consideration')}
                </div>
            </div>

            <div style={{border: "1px solid #000000", margin: "10px 0px"}}>
                <div style={{margin: "10px 15px"}}>
                    <p><b>{getLocalizedText('Electronic_Systems')}</b><br/>
                        {getLocalizedText('Electronic_Systems_Description')}
                    </p>

                    <p><b>{getLocalizedText('Nature_Of_Teleconsultation')}</b><br/>
                        {getLocalizedText('Nature_Of_Teleconsultation_Description')}
                        <ul className={"list-unstyled"}>
                            <li>
                                <p><span className={"mr-2 d-inline font-weight-bold"}>a.</span>
                                    {getLocalizedText('Nature_Of_Teleconsultation_Point1')}
                                </p>
                            </li>
                            <li>
                                <p><span className={"mr-2 d-inline font-weight-bold"}>b.</span>
                                    {getLocalizedText('Nature_Of_Teleconsultation_Point2')}
                                </p>
                            </li>
                        </ul>
                    </p>

                    <p><b>{getLocalizedText('Medical_Information_And_Records')}</b>
                        {getLocalizedText('Medical_Information_Description')}
                    </p>

                    <p><b>{getLocalizedText('Confidentiality')}</b>
                        {getLocalizedText('Confidentiality_Description')}
                    </p>

                    <p><b>{getLocalizedText('Rights')}</b>
                        {getLocalizedText('Rights_Description')}
                    </p>

                    <p><b>{getLocalizedText('Expected_Benefits')}</b><br/>
                        <ul className={"list-unstyled"}>
                            <li>
                                <p><span className={"mr-2 d-inline font-weight-bold"}>a.</span>
                                    {getLocalizedText('Expected_Benefits_Point1')}
                                </p>
                            </li>
                            <li>
                                <p><span className={"mr-2 d-inline font-weight-bold"}>b.</span>
                                    {getLocalizedText('Expected_Benefits_Point2')}
                                </p>
                            </li>
                        </ul>
                    </p>
                    <p><b>{getLocalizedText('Possible_Risks')}</b><br/>
                        {getLocalizedText('Possible_Risks_Description')}
                        <ul className={"list-unstyled"}>
                            <li>
                                <p><span className={"mr-2 d-inline font-weight-bold"}>a.</span>
                                    {getLocalizedText('Possible_Risks_Point1')}
                                </p>
                            </li>
                            <li>
                                <p><span className={"mr-2 d-inline font-weight-bold"}>b.</span>
                                    {getLocalizedText('Possible_Risks_Point2')}
                                </p>
                            </li>
                            <li>
                                <p><span className={"mr-2 d-inline font-weight-bold"}>c.</span>
                                    {getLocalizedText('Possible_Risks_Point3')}
                                </p>
                            </li>
                            <li>
                                <p><span className={"mr-2 d-inline font-weight-bold"}>d.</span>
                                    {getLocalizedText('Possible_Risks_Point4')}
                                </p>
                            </li>
                        </ul>
                    </p>
                </div>
            </div>

            <div style={{border: "1px solid #000000", margin: "10px 0px"}}>
                <div style={{margin: "10px 15px"}}>
                    <p><b>{getLocalizedText('Questions_And_Concerns')}</b><br/>
                        {getLocalizedText('Questions_And_Concerns_Section1_Description')}
                    </p>

                    <p>
                        <ul className={"list-unstyled"}>
                            <li>
                                <p><span className={"mr-2 d-inline font-weight-bold"}>a.</span>
                                    {getLocalizedText('Questions_And_Concerns_Section1_Point1')}
                                </p>
                            </li>
                            <li>
                                <p><span className={"mr-2 d-inline font-weight-bold"}>b.</span>
                                    {getLocalizedText('Questions_And_Concerns_Section1_Point2')}
                                </p>
                            </li>
                            <li>
                                <p><span className={"mr-2 d-inline font-weight-bold"}>b.</span>
                                    {getLocalizedText('Questions_And_Concerns_Section1_Point3')}
                                </p>
                            </li>
                        </ul>
                    </p>

                    <p>
                        {getLocalizedText('Questions_And_Concerns_Section2_Description')}
                        <ul className={"list-unstyled"}>
                            <li>
                                <p><span className={"mr-2 d-inline font-weight-bold"}>a.</span>
                                    {getLocalizedText('Questions_And_Concerns_Section2_Point1')}
                                </p>
                            </li>
                            <li>
                                <p><span className={"mr-2 d-inline font-weight-bold"}>b.</span>
                                    {getLocalizedText('Questions_And_Concerns_Section2_Point2')}
                                </p>
                            </li>
                            <li>
                                <p><span className={"mr-2 d-inline font-weight-bold"}>c.</span>
                                    {getLocalizedText('Questions_And_Concerns_Section2_Point3')}
                                </p>
                            </li>
                            <li>
                                <p><span className={"mr-2 d-inline font-weight-bold"}>d.</span>
                                    {getLocalizedText('Questions_And_Concerns_Section2_Point4')}
                                </p>
                            </li>
                            <li>
                                <p><span className={"mr-2 d-inline font-weight-bold"}>e.</span>
                                    {getLocalizedText('Questions_And_Concerns_Section2_Point5')}
                                </p>
                            </li>
                        </ul>
                    </p>
                </div>
            </div>

            <div style={{border: "1px solid #000000", margin: "10px 0px"}}>
                <div style={{margin: "10px 15px"}}>
                    <p>
                        {getLocalizedText('Questions_And_Concerns_Section3_Description')}
                        <ul className={"list-unstyled"}>
                            <li>
                                <p><span className={"mr-2 d-inline font-weight-bold"}>a.</span>
                                    {getLocalizedText('Questions_And_Concerns_Section3_Point1')}
                                </p>
                            </li>
                            <li>
                                <p><span className={"mr-2 d-inline font-weight-bold"}>b.</span>
                                    {getLocalizedText('Questions_And_Concerns_Section3_Point2')}
                                </p>
                            </li>
                            <li>
                                <p><span className={"mr-2 d-inline font-weight-bold"}>c.</span>
                                    {getLocalizedText('Questions_And_Concerns_Section3_Point3')}
                                </p>
                            </li>
                            <li>
                                <p><span className={"mr-2 d-inline font-weight-bold"}>d.</span>
                                    {getLocalizedText('Questions_And_Concerns_Section3_Point4')}
                                </p>
                            </li>
                        </ul>
                    </p>
                </div>
            </div>

            <div style={{border: "1px solid #000000", margin: "10px 0px", display: "flex"}}>
                <div style={{flex: 1, margin: "10px 15px"}}>
                    <p><b>{getLocalizedText('Final_Consent_Statement')}</b></p>
                </div>
                <div style={{borderLeft: "1px solid #000000", padding: "10px"}}>
                    <p className="display-flex">
                        <FormField ref={pushFormFieldRef} required validateOn={participateInTeleconsultation}>
                            <YesNoRadioInput id="participateInTeleconsultation" enumLabel={enumLabel}
                                             value={participateInTeleconsultation} readOnly={readOnly}
                                             onValueChange={(value) => onChange("participateInTeleconsultation", value)}/>
                        </FormField>
                    </p>
                </div>
            </div>

            <div className={"container"}>
                <div className={"row"} style={{marginTop: "10px"}}>
                    <div className="col-md-3 dim14-form-label">
                        {getLocalizedText('Date')}
                    </div>

                    <div className="col-md-3">
                        {readOnly && form.patientDate ?
                            ConsentFormsUtil.formatSignatureDate(form.patientDate)
                            :
                            ConsentFormsUtil.formatSignatureDate(patientDate)
                        }
                    </div>
                </div>

                <div className="row" style={{marginTop: "15px"}}>
                    <div className="col-md-3 dim14-form-label">
                        {getLocalizedText('Patient_Name')}
                    </div>
                    <div className="col-md-3">
                        {patientName}
                    </div>
                    <div className="col-md-3 dim14-form-label">
                        {getLocalizedText('Provider_Name')}
                    </div>
                    <div className="col-md-3">
                        <TextInput value={providerName} required validateOn={true}
                                   disabled style={{textAlign: "center"}}/>
                    </div>

                </div>

                <div className={"row"} style={{marginTop: "10px"}}>
                    <div className="col-md-3 dim14-form-label">
                        {getLocalizedText('Print_Name')}
                    </div>
                    <div className="col-md-3">
                        <FormField ref={pushFormFieldRef}
                            disabled={!isPatientMinor}
                            required requiredMessage={getLocalizedText('Field_Required')}
                            validateOn={guardianName}>
                            <TextInput value={guardianName}
                                disabled={readOnly} alphabeticOnly style={{ textAlign: "center" }}
                                onChange={(val) => onChange("guardianName", val)} />
                        </FormField>
                    </div>
                </div>
                <div className={"row"} style={{marginTop: "10px"}}>
                    <div className="col-md-3 dim14-form-label">
                        {getLocalizedText('Relationship_To_Patient')}
                    </div>
                    <div className="col-md-3 dim14-base-input">
                        <FormField ref={pushFormFieldRef}
                            disabled={!isPatientMinor}
                            required requiredMessage={getLocalizedText('Field_Required')}
                            validateOn={guardianRelationship}>
                            <TextInput
                                value={guardianRelationship}
                                disabled={readOnly} alphabeticOnly style={{ textAlign: "center" }}
                                onChange={(val) => onChange("guardianRelationship", val)} />
                        </FormField>
                    </div>
                </div>

                <div className={"row"} style={{marginTop: "10px"}}>
                    <div className="col-md-6 dim14-form-label">
                        {getLocalizedText('Patient_Signature')}
                    </div>
                    <div className="col-md-6 dim14-form-label">
                        {getLocalizedText('Provider_Signature')}
                    </div>
                </div>

                <div className={"row"} style={{marginTop: "15px"}}>
                    <div className="col-md-6">
                        <FormField ref={pushFormFieldRef} required validateOn={patientSignature}
                                   requiredMessage={getLocalizedText('Signature_Required')}>
                            <SignatureInput signature={patientSignature}
                                            onSave={onSavePatientSignature} readOnly={readOnly}/>
                        </FormField>
                    </div>
                    <div className="col-md-6">
                        <FormField ref={pushFormFieldRef} required validateOn={providerSignature}
                                   requiredMessage={getLocalizedText('Signature_Required')}>
                            <SignatureDisplay signature={providerSignature}/>
                        </FormField>
                    </div>
                </div>
            </div>

            <br/>
            {/* Witness/Guardian Section - Required for minor patients */}
            <div className={"container mt-4"}>
                <div className={"row"} style={{marginTop: "10px"}}>
                    <p className="font-weight-bold">
                        <u>{getLocalizedText('Official_Use_Only')}</u></p>
                    <p className="font-weight-bold">
                        {getLocalizedText('Witness_Statement_Header')}</p>
                    <p><i>{getLocalizedText('Witness_Statement')}</i></p>
                </div>

                <div className={"row"} style={{marginTop: "10px"}}>
                    <div className="col-md-6 dim14-form-label">
                        {getLocalizedText('Witness_Name')}
                    </div>
                    <div className="col-md-6">
                        <TextInput value={witnessName}
                                   disabled={readOnly} alphabeticOnly style={{textAlign: "center"}}
                                   onChange={(val) => onChange("witnessName", val)}/>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-6">{getLocalizedText('Witness_Signature')}</div>
                    <div className="col-md-6">
                        <SignatureInput
                            signature={witnessSignature}
                            onSave={onSaveWitnessSignature} readOnly={readOnly}/>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TeleconsultationWizardPage;
